import { render, staticRenderFns } from "./NewAttestation.vue?vue&type=template&id=2ad60abe&scoped=true"
import script from "./NewAttestation.vue?vue&type=script&lang=js"
export * from "./NewAttestation.vue?vue&type=script&lang=js"
import style0 from "./NewAttestation.vue?vue&type=style&index=0&id=2ad60abe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad60abe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ad60abe')) {
      api.createRecord('2ad60abe', component.options)
    } else {
      api.reload('2ad60abe', component.options)
    }
    module.hot.accept("./NewAttestation.vue?vue&type=template&id=2ad60abe&scoped=true", function () {
      api.rerender('2ad60abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/AttestationManager/NewAttestation.vue"
export default component.exports